import { request } from 'umi';

export async function getUserApi() {
  return request<API.User>('/user/me');
}

export async function putUserApi(params: API.PutUserPersonalParams | API.PutUserPasswordParams) {
  return request<API.User>('/user/me', {
    method: 'put',
    data: params,
  });
}

export async function getAllUsersApi(params?: {
  page?: number;
  page_size?: number;
  ordering?: string;
  search?: string;
}) {
  return request<API.PageDataType<API.User>>('/user/all', {
    method: 'get',
    params,
  });
}

export async function updateUserByAdminApi(id: string, data: Partial<API.User>) {
  return request<API.User>('/user', {
    method: 'put',
    params: { id },
    data,
  });
}
